import PropTypes from "prop-types";
import React, { Component } from "react";
import ButtonBase from "@material-ui/core/ButtonBase/ButtonBase";
import {
    Container, Text,
} from "../../../../../../components/index";
import { SelectedIcon } from "./SelectedIcon";
import { InfoIcon } from "./InfoIcon";
import {di} from "../../../../../../bottle";
import styles from "./styles";


// class definition
export class AccessoryCard extends Component {

    static propTypes = {
        part: PropTypes.any,
        selected: PropTypes.bool,
        onPress: PropTypes.func,
        onInfoPress: PropTypes.func
    };

    static defaultProps = {
        selected: false,
        onPress: () => undefined,
        onInfoPress: () => undefined
    };

    render() {

        // resolve inputs
        const { part, selected, onPress, onInfoPress } = this.props;
        const hidePrice = di.profileManager.hidePrice()

        // calculate price
        let price = "";

        if(!hidePrice) {
            price = di.profileManager.localizePrice(di.catalogManager.priceForPart(part.sku));
            const modelPrice = di.catalogManager.priceForPart(part.sku, di.garage.bikeModel.sku);
            if (modelPrice != undefined) {
                price = di.localization.get("build.accessory.retailPrice", di.profileManager.localizePrice(modelPrice), price);
            }
        }

        // render wide container if required
        const backgroundStyle = selected ? styles.selected : {};

        return (
            <Container style={styles.backing}>
                <ButtonBase onClick={onPress}>
                    <Container
                        flex
                        style={{...styles.cardContainer, ...backgroundStyle}}
                        justify="space-between"
                        direction="row"
                    >
                        <Container
                            flex
                            style={styles.header}
                            alignItems="flex-start"
                            justify="space-between"
                            alignContent="space-between"
                        >
                            <Text style={styles.title} bold>{part.name}</Text>
                            <Container alignItems="flex-end">
                                <Text style={styles.price}>{price}</Text>
                                <Container style={styles.divider} />
                            </Container>
                        </Container>
                        <img style={styles.image} src={di.assetManager.getImage(part.image.uri)}/>
                    </Container>
                    <SelectedIcon style={styles.selectedIcon} selected={selected} />
                </ButtonBase>
                <InfoIcon style={styles.info} onPress={onInfoPress} />
            </Container>
        );
    }
}




// WEBPACK FOOTER //
// ./src/pages/Customization/components/Customize/components/Inventory/AccessoryCard.js